export const parseCurlCommand = (curlCommand) => {
  const result = {
    method: "GET",
    url: "",
    headers: {},
    body: "",
    queryParams: [],
  };

  let command = curlCommand.trim();
  if (command.startsWith("curl ")) {
    command = command.substring(5);
  }

  const urlRegex = /(?:^|\s)(['"]?)((https?):\/\/[^\s'"]+)\1/i;
  const methodRegex = /-X\s*(['"]?)([A-Z]+)\1/i;
  const headerRegex = /-H\s*(['"]?)([^'"]+): ([^'"]+)\1/gi;
  const dataRegex = /-d\s*(['"]?)(.+?)\1(?:\s|$)/i;
  const jsonDataRegex = /-d\s*(['"]?)(\{.+?\})\1(?:\s|$)/is;
  const formDataRegex = /--data-urlencode\s+(['"]?)([^=]+=[^'"]+)\1/gi;

  const urlMatch = command.match(urlRegex);
  if (urlMatch && urlMatch[2]) {
    result.url = urlMatch[2];

    const urlObj = new URL(result.url);
    const searchParams = new URLSearchParams(urlObj.search);
    searchParams.forEach((value, key) => {
      result.queryParams.push({ idapiparams: Math.floor(1000 + Math.random() * 9000), key, value });
    });

    if (result.queryParams.length > 0) {
      result.url = result.url.split("?")[0];
    }
  }

  const methodMatch = command.match(methodRegex);
  if (methodMatch && methodMatch[2]) {
    result.method = methodMatch[2];
  }

  let headerMatch;
  const headers = {};
  while ((headerMatch = headerRegex.exec(command)) !== null) {
    headers[headerMatch[2]] = headerMatch[3];
  }
  result.headers = JSON.stringify(headers, null, 2);

  const jsonDataMatch = command.match(jsonDataRegex);
  if (jsonDataMatch && jsonDataMatch[2]) {
    try {
      const jsonBody = JSON.parse(jsonDataMatch[2]);
      result.body = JSON.stringify(jsonBody, null, 2);
    } catch (e) {
      result.body = jsonDataMatch[2];
    }
  } else {
    const dataMatch = command.match(dataRegex);
    if (dataMatch && dataMatch[2]) {
      try {
        const jsonBody = JSON.parse(dataMatch[2]);
        result.body = JSON.stringify(jsonBody, null, 2);
      } catch (e) {
        result.body = dataMatch[2];
      }
    }
  }

  let formDataMatch;
  while ((formDataMatch = formDataRegex.exec(command)) !== null) {
    const paramPair = formDataMatch[2].split("=");
    if (paramPair.length === 2) {
      result.queryParams.push({
        idapiparams: Math.floor(1000 + Math.random() * 9000),
        key: paramPair[0],
        value: paramPair[1],
      });
    }
  }

  return result;
};
